import React from "react";
import { useParams } from "react-router";

import config from "../../../config/config";
import "./AnalyticalMethods.scss";

const ESRDAnalyticalMethods2026 = () => {
  const { year } = useParams();

  const download = (refNum) => {
    const url = `${config.baseUri}/analyticalMethods?year=${year}&fileName=${refNum}&volumeNumber=2`;
    window.location = url;
  };

  if (process.env.REACT_APP_BUILD === "production")
  {
    return ("This chapter is currently not available")
  }
  
  return (
    <div>
      <h1>Supplemental Methods</h1>
      <ul>
        <li>
          <button onClick={() => download("Data Sources for the ESRD Volume")}>
            Data Sources for the ESRD Volume
          </button>
        </li>
        <li
          onClick={() => download("Codes_for_Cause_of_Hospitalization___ESRD_Volume_2025")}>
          <button>Codes for Cause of Hospitalization – ESRD Volume</button>
        </li>
        <li onClick={() => download("Cause_of_Death___ESRD_Volume_2025")}>
          <button>Codes for Cause of Death – ESRD Volume</button>
        </li>
        <li
          onClick={() => download("Codes_and_Algorithm_for_Common_CVDs_2025")}>
          <button>Codes and Algorithm for CVD and Procedure</button>
        </li>
        <li
          onClick={() => download("Codes_for_Cause_of_ESRD_2025")}>
          <button>Codes for Cause of ESRD</button>
        </li>
        <li
          onClick={() => download("DRG_Codes_For_Type_of_Hospitalization_2025")}>
          <button>DRG Codes for Type of Hospitalization</button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Prescription_Drug_Classes_2025")}>
            Codes for Prescription Drug Classes
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Loss_of_Patency_Interventions_2025")}>
            Codes for Loss of Patency Interventions
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Complications_of_Home_Dialysis_2025")}>
            Codes for Complications of Home Dialysis
          </button>
        </li>
        <li>
          <button onClick={() => download("Codes_for_Cause_of_ESRD_in_Children_2025")}>
            Codes for Cause of ESRD in Children
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ESRDAnalyticalMethods2026;
